import React from 'react';
import { SideWinLossBreakdown } from '../../utils/tradeWindowEvaluation';

export interface SideBreakdownSummaryProps {
  breakdown: SideWinLossBreakdown;
}

const SideBreakdownSummary: React.FC<SideBreakdownSummaryProps> = ({ breakdown }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
      gap: 10,
      marginBottom: 14,
    }}
  >
    <SideBreakdownCard
      title="LONG"
      wins={breakdown.longWins}
      losses={breakdown.longLosses}
      accent="#198754"
    />
    <SideBreakdownCard
      title="SHORT"
      wins={breakdown.shortWins}
      losses={breakdown.shortLosses}
      accent="#dc3545"
    />
  </div>
);

function SideBreakdownCard({
  title,
  wins,
  losses,
  accent,
}: {
  title: 'LONG' | 'SHORT';
  wins: number;
  losses: number;
  accent: string;
}) {
  const total = wins + losses;
  const winRate = total > 0 ? (wins / total) * 100 : 0;
  return (
    <div
      style={{
        background: '#f8f9fa',
        border: '1px solid #e9ecef',
        borderRadius: 6,
        padding: '10px 12px',
      }}
    >
      <div style={{ fontSize: 12, fontWeight: 700, color: accent, marginBottom: 6 }}>{title}</div>
      <div style={{ fontSize: 13, color: '#212529', marginBottom: 4 }}>
        <span style={{ color: '#198754', fontWeight: 600 }}>{wins} won</span>
        {' · '}
        <span style={{ color: '#dc3545', fontWeight: 600 }}>{losses} lost</span>
      </div>
      <div style={{ fontSize: 11, color: '#6c757d' }}>
        {total > 0 ? `${winRate.toFixed(0)}% win rate (${total} trades)` : 'No trades in window'}
      </div>
    </div>
  );
}

export default SideBreakdownSummary;
